import { Box, Typography } from '@mui/material'
import { GRAY_800, GRAY_900 } from 'constants/styling/theme'
import React, { ReactNode } from 'react'
import {
  TransformComponent,
  TransformWrapper,
  useControls,
  useTransformComponent
} from 'react-zoom-pan-pinch'

import AddIcon from '@mui/icons-material/Add'
import { MUIDivider } from 'components/common/MUIDivider'
import RemoveIcon from '@mui/icons-material/Remove'
import Stack from '@mui/material/Stack'
import { WHITE } from 'constants/styling/upbrandingTheme'

interface Props {
  /** The image to be displayed inside the ZoomPanel */
  children?: ReactNode
  /** Initial scale of the image when the ZoomPanel is rendered. */
  initialScale?: number
}

/**
 * @component
 * Image zoom panel component that allows users to zoom in and out of an image.
 *
 * @example
 * <ZoomPanel
 *   children={<img src="path/to/image.jpg" alt="Zoomable content" />}
 * />
 */
export const ZoomPanel: React.FC<Props> = ({
  children,
  initialScale = 0.8
}) => {

  return (
    <TransformWrapper
      initialScale={initialScale}
      initialPositionX={200}
      initialPositionY={100}
      minScale={0.25}
    >
      <Stack alignItems="center" width="100%" justifyContent="flex-start">

        <ZoomControls />

        <Stack alignItems="center" height="100%" width="100%">
          <TransformComponent>
            {children}
          </TransformComponent>
        </Stack>

      </Stack>
    </TransformWrapper>
  )
}

const ZoomControls = () => {
  const { zoomIn, zoomOut } = useControls()

  const zoomScale = useTransformComponent(({ state }) => {

    return (
      <Box width="3.5rem">
        <Typography variant="text-sm" fontWeight={600} color={WHITE}>{Math.round(state.scale * 100)}%</Typography>
      </Box>
    )
  })

  return (
    <Stack flexDirection="row" justifyContent="center" alignItems="center" margin="2.4rem 0">
      <Stack flexDirection="row" height="3.2rem" alignItems="center" borderRadius="3rem" padding=".6rem 1.6rem" border={`1px solid ${GRAY_900}`}>

        <Stack onClick={() => zoomOut()}>
          <RemoveIcon sx={{ color: WHITE }} />
        </Stack>

        <MUIDivider orientation="vertical" margin={12} color={GRAY_800} />

        {zoomScale}

        <MUIDivider orientation="vertical" margin={12} color={GRAY_800} />

        <Stack onClick={() => zoomIn()}>
          <AddIcon sx={{ color: WHITE }} />
        </Stack>

      </Stack>
    </Stack>
  )
}
